<template>
  <div class="page-content">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>监控中心</el-breadcrumb-item>
      <el-breadcrumb-item><span style="cursor: pointer;" @click="onChangePage(1)">监控产品</span></el-breadcrumb-item>
      <el-breadcrumb-item><span style="cursor: pointer;" @click="onChangePage(2)">产品监控计划列表</span></el-breadcrumb-item>
      <el-breadcrumb-item>{{ isAdd ? '新建监控计划' : '编辑监控计划' }}</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="g-content-box">
			<div style="padding: 0 20%;" v-if="isAdd">
				<el-steps :active="currentStep" align-center>
					<el-step title="填写平台、产品与限价"></el-step>
					<el-step title="填写监控信息，完成"></el-step>
				</el-steps>
			</div>
			<div style="padding: 20px 5%" v-if="currentStep === 0 || !isAdd">
				<el-form :model="addForm" ref="addForm" label-width="120px">
					<el-form-item
						label="监控平台"
						required>
						<el-select style="width: 250px" multiple v-model="addForm.platforms" size="small" placeholder="请选择" @change="onPlatformChange">
							<el-option v-for="item in platformList"
								:key="item.value"
								:label="item.label"
								:value="item.value">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item
						label="限价标准"
						required>
						<el-radio-group v-model="addForm.limitpricetype">
							<el-radio label="1">各平台不同</el-radio>
							<el-radio label="0">各平台相同</el-radio>
						</el-radio-group>
					</el-form-item>
					<el-form-item
						label="监控产品型号"
						required>
						<el-button class="add-product-btn" style="border-style: dotted; width: 250px" @click="onShowSelectPro" type="plain">+ 添加监控产品</el-button>
						<div class="price-box" style="padding: 20px;" v-if="treeData.length !== 0">
							<SingleProductItem
								v-for="(item, index) in treeData" :key="index"
								:limitpricetype="addForm.limitpricetype"
								:item="item"
								@onBlur="obj => handleItem(obj, index)"
								@on-delete="onDeleteProduct(index)"
							/>
						</div>
					</el-form-item>
					<el-form-item v-if="isAdd">
						<el-button type="primary" size="small" class="g-confirm-btn" @click="onGotoNext">下一步</el-button>
					</el-form-item>
				</el-form>
			</div>
			<div style="padding: 20px 5%" v-if="currentStep === 1 || !isAdd">
				<el-form :model="secondAddForm" ref="secondAddForm" label-width="120px">
					<el-form-item
						label="监控计划名称"
						required>
						<el-input style="width: 60%" size="small" maxlength="50" v-model="secondAddForm.planname" placeholder="请输入计划名称"></el-input>
					</el-form-item>
					<el-form-item
						label="每日监控时间"
						required>
						<el-select
							size="small"
							v-model="secondAddForm.plathour"
							multiple
							placeholder="请选择"
							:multiple-limit="limitMonitorTimeNum"
						>
							<el-option
								v-for="item in time"
								:key="item"
								:label="item"
								:value="item">
							</el-option>
						</el-select>
						<span class="g-margin-left" style="color: red;">你最多可以选择{{ limitMonitorTimeNum }}个时间</span>
					</el-form-item>
					<el-form-item
						label="监控类型"
						required>
						<el-radio-group v-model="secondAddForm.plantype" :disabled="!isAdd">
							<el-radio label="0">标价</el-radio>
							<el-radio v-if="handlePriceVis" label="1">到手价</el-radio>
						</el-radio-group>
					</el-form-item>
					<el-form-item label="通知人微信">
						<el-select
							:multiple-limit="5"
							size="small"
							multiple
							@visible-change	="onWechatSelcet"
							v-model="secondAddForm.noticeuserid"
							placeholder="暂无通知人微信">
							<el-option
								v-for="item in wecharList"
								:key="item.openid"
								:value="item.openid"
								:label="item.nickname"
							>
							</el-option>
						</el-select>
						<span @click="addWechatPerson" class="g-margin-left add-person-btn">新增通知人</span>
					</el-form-item>
					<el-form-item>
						<el-button type="primary" size="small" class="g-confirm-btn" @click="onStartMonitor">开始监控</el-button>
						<el-button v-if="isAdd" type="plain" size="small" @click="currentStep -= 1">上一步</el-button>
					</el-form-item>
				</el-form>
			</div>
		</div>
		<el-dialog
			class="product"
			:visible.sync="productVisible"
			width="1000px"

      >
			<span style="color: red" slot="title">监控产品上限: {{ currentProNum }} / {{ allLimitProNum }}</span>
			<el-row>
				<el-col :span="12" style="border-right: 1px soild gray">
					<div class="g-center">全部产品</div>
					<el-row class="g-margin-top">
						<el-col :span="6">产品名称</el-col>
						<el-col :span="18">
							<el-input
								size="small"
								v-model="filterText">
							</el-input>
							<el-tree
								:default-checked-keys="treeDefaultData"
								:data="getShopProducts"
								show-checkbox
								node-key="id"
								:props="defaultProps"
								class="filter-tree"
								@check-change="handleTreeChange"
                :load="clickTree"
                lazy
								:filter-node-method="filterNode"
								ref="tree">
							</el-tree>
						</el-col>
					</el-row>
				</el-col>
				<el-col :span="12">
					<div class="g-center">已选产品</div>
					<div class="g-margin-top" style="margin-left: 30px;">
						<span class="g-block" v-for="(item, index) in selectTreeData" :key="index">
							{{ item.label }}
						</span>
					</div>
				</el-col>
			</el-row>
			<span slot="footer">
				<el-button @click="onFinishProduct" size="small" class="g-confirm-btn">完成</el-button>
			</span>
		</el-dialog>
		<ComfirmDialog
			:visible="confirmVisible"
			@on-close="confirmVisible = false"
			@on-comfirm="handleDeleteProduct"
		>
			<div slot="content" class="g-center">
				<i style="color: #efb141; font-size: 35px" class="el-icon-warning"></i>
				<span class="g-margin-left">确认删除该产品吗?</span>
			</div>

		</ComfirmDialog>
    <wxBindingComponent ref="childWxBinding"/>
  </div>
</template>

<script>
import _ from 'lodash'
import ComfirmDialog from 'components/comfirmDialog/comfirmDialog'
import SingleProductItem from './components/singleProductItem'
import { mapState, mapGetters, mapActions } from 'vuex';
import wxBindingComponent from "../../../components/wxComponent/wxBindingComponent.vue";
export default {
  name: 'DataInfomation',

  components:{
		ComfirmDialog,
		SingleProductItem,
    wxBindingComponent
	},

	watch: {
		// 根据用户输入过滤树形控件数据
    filterText(val) {
      this.$refs.tree.filter(val);
    }
  },

  data () {
    return {
      newArrNum: [],
			wechatUrl: '',
			deleteIndex: 0,
			editStatus: 1,
			currentTreeDataLen: 0,
			currentProNum: 0,
			originPorNum: 0,
			treeDefaultData: [],
			isAdd: false,
			limitMonitorTimeNum: 2,
			handlePriceVis: false,
			allLimitProNum: 0,
			limitData: [],
			platformList: [
				{ value: 'PDD', label: '拼多多' },
				{ value: 'TB', label: '淘宝' },
				{ value: 'TM', label: '天猫' },
				{ value: 'JD', label: '京东' },
				{ value: 'SN', label: '苏宁' },
			],
			time: [],
			secondAddForm: {
				noticeuserid: [],
				plathour: [],
				planname: '',
				plantype: ''
			},
			confirmVisible: false,
			defaultProps: {
        value: 'id',
        label: 'productClassifyName',
        isLeaf: 'leaf'
      },
			filterText: '',
			productVisible: false,
			addForm: {
				limitpricetype: '1',
				platforms: [],

			},
			options: [
				{ value: 1, label: '1' },
				{ value: 2, label: '2' },
				{ value: 3, label: '3' },
			],
			currentStep: 0,
			treeData: [],
			selectTreeData: []
    }
  },
  created(){
  },
  methods: {
		// 选择微信通知人的回调
		onWechatSelcet(v) {
			v && this.reqWecharList();
		},
		// 添加微信通知人
		addWechatPerson() {
			this.$refs.childWxBinding.getbmcwx('m',this.userInfo.bid,this.userInfo.openid)
		},
		// 输入限价标准后的回调
		handleItem(obj, index) {
			if(obj.platform) {
				this.treeData[index].limitData.map(item => {
					if(item.platform === obj.platform) {
						item.value = obj.value;
					}
					return item;
				})
			}else {
				this.treeData[index].value = obj.value;
			}
		},
		// 添加产品，要回显树形控件数据，直接不能回显数据，所以用了延迟
		onShowSelectPro() {
			this.productVisible = true;
			let keys = this.treeData.reduce((res, cur) => {
				res.push(`${cur.id},${cur.label}`)
				return res;
			}, [])
			setTimeout(() => {
				this.$refs.tree.setCheckedKeys(keys, true)
				this.handleTreeChange()
			}, 200);
		},
		// 处理删除产品
		handleDeleteProduct() {
			this.treeData.splice(this.deleteIndex, 1);
			this.confirmVisible = false;
		},
		// 改变平台的回调
		onPlatformChange(arr) {
			this.limitData = this.platformList.reduce((all, cur) => {
				if(arr.includes(cur.value)) {
					all.push({
						platform: cur.value,
						label: cur.label,
					})
				}
				return all
			}, [])
			this.treeData.map(item => {
				item.limitData = _.cloneDeep(this.limitData);
			});
		},
		// 处理树形控件的数据
		handleTreeData() {
			let res = [];
			if(this.addForm.limitpricetype === '0') {
				return this.treeData.reduce((res, cur) => {
					this.addForm.platforms.forEach(platform => {
						res.push({
							platform,
							productid: cur.id,
							price: cur.value
						})
					})
					return res;
				}, [])
			}else {
				return this.treeData.reduce((res, cur) => {
					cur.limitData.forEach(limitItem => {
						res.push({
							platform: limitItem.platform,
							productid: cur.id,
							price: limitItem.value
						})
					})
					return res;
				}, [])
			}
		},
		// 点击产品选择框完成的回调
		onFinishProduct() {
			if(this.currentProNum > this.allLimitProNum) {
				this.$message.error('超出最大可监控产品数');
				return;
			}
			this.productVisible = false;
			this.treeData = _.cloneDeep(this.selectTreeData);
		},
		// 开始监控，处理数据
		onStartMonitor() {
			if(this.isAdd) {
				if(!this.vertifySecondForm()) {
					return;
				}
			}else {
				if(!this.vertifyAddForm() || !this.vertifySecondForm()) {
					return;
				}
			}
			let data = {
				noticeuserid: this.secondAddForm.noticeuserid.join(','),
				plathour: this.secondAddForm.plathour.join(','),
				planname: this.secondAddForm.planname,
				plantype: this.secondAddForm.plantype,
				platform: this.addForm.platforms.join(','),
				limitpricetype: this.addForm.limitpricetype,
				childList: this.handleTreeData()
			}
			if(!this.isAdd) {
				data.id = parseInt(this.$route.params.id);
				data.status = this.editStatus;
			}else {
				data.status = 1;
			}
			fetch({
				method: 'POST',
				url: 'hcm/hcmNewMonitorProduct/save',
				data: JSON.stringify(data),
				headers: {
					'Content-Type': 'application/json'
				}
			}).then(res => {
				if(res.status === '10000') {
					this.$message.success(this.isAdd ? '新增计划成功' : '编辑计划成功');
					this.$router.push('/MonitorPlan');
				}
			})
		},
		// 判断表单中限价有没有填
		isFillInPrice() {
			if(this.addForm.limitpricetype === '0') {
				return this.treeData.every(item => item.value);
			}else {
				return this.treeData.every(item => {
					let limitData = item.limitData;
					return limitData.every(limitItem => limitItem.value);
				})
			}
		},
		// 验证第一个表单
		vertifyAddForm() {
			if(!this.addForm.platforms.length) {
				this.$message.error('请选择平台')
				return false;
			}
			if(!this.treeData.length) {
				this.$message.error('请添加产品型号')
				return false;
			}
			if(!this.addForm.limitpricetype) {
				this.$message.error('请选择限价标准')
				return false;
			}
			if(!this.isFillInPrice()) {
				this.$message.error('请填写各平台限价')
				return false;
			}
			return true;
		},
		// 验证第二个表单
		vertifySecondForm() {
			if(!this.secondAddForm.planname) {
				this.$message.error('请填写计划名称')
				return false;
			}
			if(!this.secondAddForm.plathour.length) {
				this.$message.error('请选择监控时间')
				return false;
			}
			if(!this.secondAddForm.plantype) {
				this.$message.error('请选择监控类型')
				return false;
			}
			return true;
		},
		// 从第一个表单到第二个表单
		onGotoNext() {
			if(this.vertifyAddForm()) {
				this.currentStep += 1;
			}
		},
		// 删除产品
		onDeleteProduct(index) {
			this.deleteIndex = index;
			this.confirmVisible = true;
		},
    // 数据过慢添加一个加载效果
    clickTree(node, resolve) {
      console.log(this.getShopProducts)
      if (node.level === 0) {
         return resolve(this.getShopProducts);
      }
      if (node.level === 1) {
        for(let i = 0; i < this.getShopProducts.length ;i++) {
          for(let a = 0; a < this.getShopProducts[i].children.length ;a++) {
            this.getShopProducts[i].children[a].leaf = true
          }
          if (node.key === this.getShopProducts[i].id) {
            setTimeout(() => {
              resolve(this.getShopProducts[i].children);
            }, 1000);
          }
  			}

      }
      if (node.level > 1) {
         return resolve([]);
      }
    },
		// 处理每次树形控件改变的回调
		handleTreeChange() {
			let selectedData = this.$refs.tree.getCheckedNodes().filter((item) => {
        return !item.children;
      })

			this.currentProNum = this.isAdd ? this.originPorNum + selectedData.length : this.originPorNum - this.currentTreeDataLen + selectedData.length;
			this.selectTreeData = selectedData.reduce((all, cur) => {
				let limitData = _.cloneDeep(this.limitData);
				limitData.map(limit => {
					if(cur.addprice && cur.addprice[limit.platform]) {
						limit.value = cur.addprice[limit.platform]
					}

				})
				all.push({
					id: cur.id.split(',')[0],
					label: cur.id.split(',')[1],
					limitData,
					value: cur.addprice ? cur.addprice.ALL ? cur.addprice.ALL : '' : ''
				})
				return all
			}, [])
		},
		// 树形控件的自定义过滤方法
    filterNode(value, data) {
			if (!value) return true;
      return String(data.productClassifyName).indexOf(value) !== -1;
		},
		// 跳转页面
		onChangePage(type) {
			if(type === 2) {
				this.$router.push('/MonitorPlan')
			}else {
				this.$router.push('/ProductPandect');
			}
		},
		// 生成0 - 24点的时间
		generateMonitorTime() {
			let res = [];
			for(let i = 0; i <= 23;i++) {
				res.push(`${i}:00`)
			}
			this.time = res;
		},
		// 编辑时回显树形控件数据
		echoTreeData(data) {
			if(data.limitpricetype === 1) {
				this.treeData = data.childList.reduce((res, cur) => {
					if(res.some(item => item.label === cur.productname)) {
						let p = res.find(item => item.label === cur.productname);
						let obj = {
							platform: cur.platform,
							label: this.platformList.find(item => item.value === cur.platform).label,
							id: cur.productid,
							value: cur.price
						}
						p.limitData.push(obj);
						if(!this.limitData.some(item => item.platform === cur.platform)) {
							this.limitData.push({
								label: this.platformList.find(item => item.value === cur.platform).label,
								platform: cur.platform,
								id: cur.productid
							})
						}
					}else {
						this.treeDefaultData.push(`${cur.productid},${cur.productname}`)
						res.push({
							id: cur.productid,
							label: cur.productname,
							limitData: [{
								platform: cur.platform,
								label: this.platformList.find(item => item.value === cur.platform).label,
								id: cur.productid,
								value: cur.price
							}]
						})
						if(!this.limitData.some(item => item.platform === cur.platform)) {
							this.limitData.push({
								label: this.platformList.find(item => item.value === cur.platform).label,
								platform: cur.platform,
								id: cur.productid
							})
						}
					}
					return res;
				}, [])
			}else {
				this.treeData = data.childList.reduce((res, cur) => {

					if(!res.some(item => item.label === cur.productname)) {
						this.treeDefaultData.push(`${cur.productid},${cur.productname}`)
						res.push({
							label: cur.productname,
							value: cur.price,
							id: cur.productid
						})
					}
					return res;
				}, [])
			}
			this.currentTreeDataLen = this.treeData.length;
		},
		// 处理编辑数据后在回显
		handleEditData(id) {
			let data = this.monitorPlanList.find(item => item.id === id);
			this.addForm.platforms = data.platform.split(',');
			this.addForm.limitpricetype = String(data.limitpricetype);
			this.secondAddForm.plathour = data.plathour.split(',');
			this.secondAddForm.planname = data.planname;
			this.secondAddForm.plantype = data.plantype;
			this.secondAddForm.noticeuserid = data.noticeuserid ? data.noticeuserid.split(',') : '';
			this.editStatus = data.status;
			this.echoTreeData(data);
		},
		...mapActions([
			'reqActivityShopProduct',
			'reqWecharList',
			'reqGetbmcwx'
			// 'reqUser'
		]),
		// 加载产品监控限制数据
		loadProductLimit() {
			fetch({
				method: 'GET',
				url: 'hcm/hcmNewMonitorProduct/getProductCount'
			}).then(res => {
				if(res.status === '10000') {
					this.currentProNum = res.data;
					this.originPorNum = res.data;
				}
			})
		}
  },

  computed: {
		...mapState({
			wecharList: state => state.monitorPlan.wecharList,
			monitorPlanList: state => state.monitorPlan.monitorPlanList,
			// userInfo: state => state.myInfomation.userInfo,
			userInfo: state => state.serviceReport.userinfo,
		}),
		...mapGetters([
			"getShopProducts"
    ]),
  },

  created() {
		this.reqGetbmcwx();
		// this.reqUser();
		this.reqWecharList();
		this.loadProductLimit();
		let id = parseInt(this.$route.params.id);
		this.isAdd = id ? false : true;
		this.reqActivityShopProduct({
			type: id ? id : 'add'
		})
		if(id) {
			this.handleEditData(id)
		}

		fetch({
			url: 'hcm/cus/selectbmcSetting'
		}).then(res => {
			if(res.status === '10000') {
				id ? '' : this.addForm.limitpricetype = res.data.limitpricetype;
				this.limitMonitorTimeNum = res.data.productmonitorFrequency === 1 ? 2 : 1;
				this.handlePriceVis = res.data.productmonitorDimensionality === 1 ? true : false;
				this.allLimitProNum = res.data.productmonitorNumber;
				let ptmArr = res.data.productmonitorPlatform.split(',');
				this.platformList = this.platformList.reduce((arr, cur) => {
					if(ptmArr.includes(cur.value)) {
						arr.push(cur);
					}
					return arr;
				}, [])
				console.log(this.platformList);

			}
		})
		this.generateMonitorTime();
  },

  mounted() {},
}
</script>


<style lang='scss'>
@import "style/activityDeclaration.scss";
@import "style/myInfomation.scss";

.product .el-dialog__body {
	height: 450px;
	overflow: auto;
}

.product .el-tree-node__label {
	overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.add-person-btn {
	color: #108cee;
	cursor: pointer;
}

.price-item {
	display: flex;
	align-items: center;
}

.price-item + .price-item {
	border-top: 1px solid rgb(188, 188, 188);
}

.price-input {
	display: inline-block;
  margin-left: 10px;
  width: 120px;
}

.add-product-btn {
	border-style: dotted;
	border-color: #108cee;
	color: #108cee;
}

.price-box {
	margin-top: 5px;
	border: 1px solid rgb(213, 213, 213);
}

.breadcrumb-box .el-breadcrumb__item:last-child .el-breadcrumb__inner {
  font-weight: bold;
}

.breadcrumb-box {
  display: flex;
  align-items: center;
  width: 100%;
  height: 40px;
  background-color: #fff;
  padding-left: 20px;
}
</style>
